export enum CopilotActions {
  graphForKeyTermTrend = 'graphForKeyTermTrend',
  updateOfferRecsKeyTerms = 'updateOfferRecsKeyTerms',
  draftBuyerOffer = 'draftBuyerOffer',
  userInfo = 'userInfo',
  offerScore = 'offerScore',
  makeScoreCard = 'makeScoreCard',
}
